import { render, staticRenderFns } from "./SSwitch.vue?vue&type=template&id=597cfca8&scoped=true&"
import script from "./SSwitch.vue?vue&type=script&lang=js&"
export * from "./SSwitch.vue?vue&type=script&lang=js&"
import style0 from "./SSwitch.vue?vue&type=style&index=0&id=597cfca8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597cfca8",
  null
  
)

export default component.exports